import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, Search } from 'lucide-react';
import { api, useAuth } from '../context/AuthContext';
import { Seite } from '../components/stammakte/ui';

export default function KanzleiPortalansicht() {
  const { portalansichtStarten } = useAuth();
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [items, setItems] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => api.get('/register/mandanten', { params: { q } }).then((r) => setItems((r.data.items || []).slice(0, 30))).catch(() => setItems([])), 250);
    return () => clearTimeout(t);
  }, [q]);
  const oeffnen = (m) => { portalansichtStarten(m); navigate('/dashboard'); };
  return (
    <Seite titel="Mandantenportal" text="Vorschau: So sieht der Mandant Sachstand und Unterlagen. Nur lesen, jeder Aufruf wird protokolliert." testId="portalansicht-page">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-[17px] h-[17px] text-[#56616D]" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Name, Mandantennummer oder Aktenzeichen" className="w-full border border-[#DCE3EA] bg-white rounded-xl pl-[38px] pr-3 py-2.5 text-[15px]" data-testid="portalansicht-suche" />
      </div>
      <ul className="bg-white border border-[#DCE3EA] rounded-[14px] divide-y divide-[#10243A]/[0.07] overflow-hidden" data-testid="portalansicht-liste">
        {items.map((m) => (
          <li key={m.mandanten_nr} className="flex items-center gap-3 px-4 py-3">
            <span className="min-w-0 flex-1"><span className="text-[15.5px] text-[#15202B]">{m.name}</span> <span className="text-[#56616D]">{m.mandanten_nr}</span>
              <span className="block text-[13.5px] text-[#56616D] truncate">{m.email || 'keine E-Mail hinterlegt'}</span></span>
            <button type="button" onClick={() => oeffnen(m)} className="shrink-0 inline-flex items-center gap-1.5 h-9 px-3.5 rounded-[10px] text-[13.5px] font-semibold text-white bg-gradient-to-br from-[#1B3A5C] to-[#10243A]" data-testid={`portalansicht-oeffnen-${m.mandanten_nr}`}><Eye className="w-4 h-4" />Portal ansehen</button>
          </li>
        ))}
        {!items.length && <li className="px-4 py-6 text-center text-sm text-[#9AA5B1]">Kein Mandant gefunden.</li>}
      </ul>
    </Seite>
  );
}
